import React from "react";
import styled from "styled-components";
import { ACSS, IconClipboard, IconKnowledge, IconPhoneAid } from "@upsolve/ui";

import Logo from "../../../static/images/upsolve-logo.svg";

const MockPhone = (props) => {
  return (
    <StyledPhoneDemo cssOverrides={props.cssOverrides}>
      <div className="phone__screen">
        <div className="phone__header">
          <Logo />
        </div>
        <div className="phone__checklist">{props.children}</div>
        <div className="phone__footer">
          <IconClipboard />
          <IconPhoneAid />
          <IconKnowledge />
        </div>
      </div>
    </StyledPhoneDemo>
  );
};

const StyledPhoneDemo = styled.figure`
  position: relative;
  width: 264px;
  height: 533px;
  padding: 8px;
  user-select: none;
  border-radius: 36px;
  background: #f6f9fc;
  box-shadow: 0 50px 100px -20px rgba(50, 50, 223, 0.25), 0 30px 60px -30px rgba(0, 0, 0, 0.3),
    inset 0 -2px 6px 0 rgba(10, 37, 64, 0.35);
  &,
  .phone__screen {
    overflow: hidden;
  }
  div.phone__screen {
    position: relative;
    background: white;
    height: 100%;
    border-radius: 34px;
    display: flex;
    flex-direction: column;
  }
  div.phone__header,
  div.phone__footer {
    background: white;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid ${(props) => props.theme.colors.white[500]};
    padding: 0 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 5;
    svg {
      height: 18px;
      width: auto;
      path {
        fill: ${(props) => props.theme.colors.brand[700]};
      }
    }
  }
  div.phone__footer {
    height: 64px;
    border-bottom: 0;
    border-top: 1px solid ${(props) => props.theme.colors.white[500]};
    align-items: flex-start;
    justify-content: space-between;
    svg {
      height: 28px;
      margin: 12px 24px;
      path {
        fill: ${(props) => props.theme.colors.white[100]};
      }
    }
  }
  div.phone__checklist {
    height: 100%;
    padding: 2em 1em 0;
    & > span {
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      color: ${(props) => props.theme.colors.brand[500]};
      letter-spacing: 90%;
    }
    & > hr {
      margin: 0.75em 0 1em;
    }
    & > div.phone__checklist__step {
      transition: 250ms;
      padding: 0.5em 0.75em;
      margin: 0.5em 0;
      border-radius: 8px;
      background: ${(props) => props.theme.colors.white[500]};
      font-size: 14px;
      font-weight: 500;
      color: ${(props) => props.theme.colors.gray[900]};
      svg {
        transition: 250ms;
        position: relative;
        top: 2px;
        margin-right: 3px;
        height: 14px;
        width: 0;
        path {
          fill: white;
        }
      }
      &.done {
        background: ${(props) => props.theme.colors.green[500]};
        border: 1px solid ${(props) => props.theme.colors.green[500]};
        border-bottom: 3px solid ${(props) => props.theme.colors.green[300]};
        color: white;
      }
      &.active {
        background: ${(props) => props.theme.colors.brand[500]};
        border: 1px solid ${(props) => props.theme.colors.brand[500]};
        border-bottom: 3px solid ${(props) => props.theme.colors.brand[300]};
        color: white;
      }
      &.expanded {
        background: white;
        border: 1px solid ${(props) => props.theme.colors.white[700]};
        border-bottom: 3px solid ${(props) => props.theme.colors.white[600]};
        color: ${(props) => props.theme.colors.brand[500]};
        svg {
          path {
            fill: ${(props) => props.theme.colors.brand[500]};
          }
        }
        .explainer {
          margin: 0.5em 0;
          padding: 0.5em 0.25em 0.25em;
          border-top: 1px solid ${(props) => props.theme.colors.white[600]};
          color: ${(props) => props.theme.colors.gray[400]};
          img {
            width: 100%;
            margin-bottom: 0.25em;
          }
          p {
            margin: 0 0 0.2em;
            font-size: 10px;
            font-weight: 300;
            line-height: 150%;
            color: ${(props) => props.theme.colors.gray[900]};
            &:last-of-type {
              padding-bottom: 0.75em;
            }
          }
          b {
            text-decoration: underline;
          }
          button {
            opacity: 0.5;
            &:not(:last-of-type) {
              margin-bottom: 0.5em;
            }
          }
        }
      }
      &.done,
      &.active,
      &.expanded {
        svg {
          width: 14px;
        }
      }
    }
    & > small {
      text-align: center;
    }
  }
  .phone__sms-message {
    position: absolute;
    top: -120px;
    left: 0;
    right: 0;
    z-index: 10;
    animation: incoming-sms-message 4s ease-in-out;
    & > div {
      width: 88%;
      margin: 0 auto;
      padding: 0.5em 1em 1em;
      border-radius: 12px;
      background: ${(props) => props.theme.colors.white[600]};
      border: 1px solid ${(props) => props.theme.colors.white[500]};
      box-shadow: 0 2px 12px 0 rgba(10, 37, 64, 0.2);
      color: ${(props) => props.theme.colors.gray[500]};
      font-size: 11px;
      line-height: 120%;
      .from {
        font-size: 10px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid ${(props) => props.theme.colors.white[300]};
        padding-bottom: 0.5em;
        margin-bottom: 0.5em;
      }
    }
    @keyframes incoming-sms-message {
      0% {
        top: -120px;
      }
      10% {
        top: 15px;
      }
      90% {
        top: 15px;
      }
      100% {
        top: -120px;
      }
    }
  }
  .phone__checklist__files {
    text-align: center;
    margin: 0 0 1em;
    small {
      opacity: 0.5;
    }
    & > div {
      background: ${(props) => props.theme.colors.white[800]};
      border: 1px solid ${(props) => props.theme.colors.white[500]};
      font-size: 10px;
      margin: 0 0 0.25em;
      padding: 0.25em 0.75em;
      overflow: hidden;
      word-break: keep-all;
      text-decoration: underline;
      ${ACSS}
      display: flex;
      align-items: center;
      .icon {
        display: flex;
        align-items: center;
        width: 28px;
        height: 28px;
        background: white;
        padding: 2px;
        svg {
          height: 20px;
          width: 20px;
          path {
            fill: ${(props) => props.theme.colors.gray[900]};
          }
        }
      }
    }
  }
  .phone__preview-docs {
    position: absolute;
    top: 1000px;
    left: 0;
    right: 0;
    bottom: 48px;
    z-index: 2;
    display: flex;
    align-items: flex-end;
    &__download {
      width: 80%;
      margin: 0 auto 2em;
      border-radius: 40px;
      padding: 0.75em 1.25em;
      background: ${(props) => props.theme.colors.brand[500]};
      border-bottom: 2px solid ${(props) => props.theme.colors.brand[300]};
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: white;
      svg {
        height: 20px;
        width: 20px;
        path {
          fill: white;
        }
      }
    }
  }
  .phone__discharged {
    position: absolute;
    top: 32px;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    animation: discharged 1s;
    @keyframes discharged {
      0% {
        transform: scale(0) translateY(-120px);
      }
      100% {
        transform: scale(1) translateY(0);
      }
    }
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 4em 2em;
    text-align: center;
    p {
      line-height: 120%;
      margin: 0 0 0.75em;
      &.congrats {
        color: ${(props) => props.theme.colors.brand[500]};
        font-size: 32px;
        font-weight: 500;
      }
    }
    small {
      color: ${(props) => props.theme.colors.gray[900]};
    }
    & > div:first-of-type {
      width: 100%;
      height: 96px;
    }
  }
  ${(props) => props.cssOverrides}
`;

export default MockPhone;
